<action-bar>
  <action-button [iconClass]="'fa fa-ban'" [className]="'action-danger'" (actionClick)="cancel()">Cancel</action-button>
  <action-button [iconClass]="'fa fa-floppy-o'" [className]="'action-primary'" (actionClick)="submit()"
  [disabled]="!assignedUsers || assignedUsers.length === 0">Save</action-button>
</action-bar>
@if (alertMessage) {
  <ngb-alert class="alert-overlay"
  type="success" (close)="alertMessage = null">{{ alertMessage }}</ngb-alert>
}
<h2>Set Default Recipient of Assessment Results @if (ownerUser && isAdmin) {
  <span>for ({{ownerUser.name}})</span>
}</h2>

@if (isAdmin) {
  <div class="row">
    <div class="col-6">
      <label class="form-control-label">Client</label>
      <ps-autocomplete-select [placeHolderText]="'Select Client'"
        [selectedItem]="client"
        [selectList]="clients" (selectionChanged)="onClientChanged($event)">
      </ps-autocomplete-select>
    </div>
    <div class="col-6">
      <label class="form-control-label">Owner User</label>
      <ps-autocomplete-select [placeHolderText]="'Select Department'"
        [(selectedItem)]="ownerUser"
        [selectList]="users" (selectionChanged)="onOwnerUserChanged($event)">
      </ps-autocomplete-select>
    </div>
  </div>
}
@if (client) {
  <div class="row">
    <div class="col">
      <br/>
      <h5>Available Recipients</h5>
      <div class="select-list scroll scroll-lg select-list-striped">
        @for (item of availableUsers; track item) {
          <div class="select-list-item d-flex flex-row align-items-stretch justify-content-between flex-nowrap">
            @if (item.name) {
              <div>
                <i class="fa fa-address-card-o"></i>
                <strong>{{item.name}}</strong>&nbsp;<span class="text-muted">({{item.isSystem ? 'System' : 'Non-system'}})</span><br/>
                E: {{item.email}}<br/>
                @if (item.phoneMobile) {
                  <span>M: {{item.phoneMobile}}<br/></span>
                }
                W: {{item.phoneWork}}
              </div>
            }
            @if (!item.name) {
              <div>
                <i class="fa fa-address-card-o"></i>
                <strong>{{item.email}}</strong>&nbsp;<span class="text-muted">({{item.isSystem ? 'System' : 'Non-system'}})</span><br/>
                @if (item.phoneMobile) {
                  <span>M: {{item.phoneMobile}}<br/></span>
                }
                W: {{item.phoneWork}}
              </div>
            }
            <div class="ml-2" (click)="itemClicked(item)" style="cursor: pointer;">
              <i class="fa fa-plus-square-o fa-lg text-success"></i>&nbsp;
            </div>
          </div>
        }
      </div>
    </div>
    <div class="col">
      <br/>
      <h5>Default Recipients</h5>
      <div class="select-list scroll scroll-lg select-list-striped">
        @for (item of assignedUsers; track item) {
          <div class="select-list-item d-flex flex-row align-items-stretch justify-content-between flex-nowrap">
            <div class="mr-2" (click)="itemClicked(item)" style="cursor: pointer;">
              <i class="fa fa-trash-o text-danger fa-lg"></i>
            </div>
            @if (item.name) {
              <div>
                <i class="fa fa-address-card-o"></i>
                <strong>{{item.name}}</strong>&nbsp;<span class="text-muted">({{item.isSystem ? 'System' : 'Non-system'}})</span><br/>
                E: {{item.email}}<br/>
                @if (item.phoneMobile) {
                  <span>M: {{item.phoneMobile}}<br/></span>
                }
                W: {{item.phoneWork}}
              </div>
            }
            @if (!item.name) {
              <div>
                <i class="fa fa-address-card-o"></i>
                <strong>{{item.email}}</strong>&nbsp;<span class="text-muted">({{item.isSystem ? 'System' : 'Non-system'}})</span><br/>
                @if (item.phoneMobile) {
                  <span>M: {{item.phoneMobile}}<br/></span>
                }
                W: {{item.phoneWork}}
              </div>
            }
            <div class="d-flex ml-auto">
              <div class="form-check-inline">
                <label class="form-check-label">
                  <input class="form-check-input" type="checkbox" [ngModel]="item.verbal" (change)="verbalChanged($event, item)">
                  Verbal
                </label>
              </div>
              <div class="form-check-inline">
                <label class="form-check-label">
                  <input class="form-check-input" type="checkbox" [ngModel]="item.written" (change)="writtenChanged($event, item)">
                  Written
                </label>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
} @else {
  <p class="text-muted">Select client to see available users.</p>
}
